export default {
  Transacting: {
    page: 'Transaction History',
    title: 'History',
    tab_1: 'Transactions',
    time_1: 'All Time',
    time_2: 'Past week',
    time_3: 'Past Month',
    time_4: 'Past three Months',
    bot_tab_1: 'All',
    bot_tab_2: 'Withdrawals',
    bot_tab_3: 'Deposits',
    bot_tab_4: 'Open Order',
    bot_tab_5: 'Order History',
    no: 'No More',
    more: 'More',
    type: 'TYPE',
    date: 'DATE',
    amount: 'AMOUNT',
    address: 'ADDRESS',
    tx_id: 'Transaction Id',
    his: 'Transaction History',

    // banxa
  },
  service_provide: 'Service Provide',
  side: 'Side',
  quantity: 'Quantity',
  fee: 'Fee',
  order_id: 'Order Id',
  in_process: 'In Process',
};
